export default "__VITE_ASSET__BCSq1ia7__"